import { Tooltip } from '@packages/common-ui/components/Tooltip';
import { ImageAsset } from '@packages/common-ui/components/image';
type BackButtonProps = {
  onClick: () => void;
  label?: string;
};
export const BackButton = ({
  onClick,
  label
}: BackButtonProps) => <Tooltip content="Back to Main Page" asChild>
    <button className="flex items-center gap-x-3" type="button" onClick={onClick}>
      <ImageAsset className="w-8" src="/assets/common/back_button.webp" />
      {label && <span className="font-chakra-petch text-xs uppercase text-white">{label}</span>}
    </button>
  </Tooltip>;